import { Button } from "@brightagency/headstart-common";
import React, { ReactNode } from "react";
import { SmallModal } from "../Modal";
import { ModalCard } from "../Modal/ModalCard";
import { Title, Content } from "./styled";

interface Props {
    isVisible: boolean;
    title: string;
    content: string;
    onConfirm: () => void;
    icon?: ReactNode;
    confirmText?: string;
}

export const Notification: React.FC<Props> = props => {
    return (
        <SmallModal onClose={props.onConfirm} isVisible={props.isVisible}>
            <ModalCard>
                {props.icon && props.icon}
                <Title>{props.title}</Title>
                <Content>{props.content}</Content>
                <Button maxWidth={-1} onClick={props.onConfirm}>
                    {props.confirmText ?? "Got it"}
                </Button>
            </ModalCard>
        </SmallModal>
    );
};
